var map;
var modal;
var gmarkers = [];

$(document).ready(function() {
  $(".card-title").dotdotdot();
  $("label.place").dotdotdot();

  $(window).resize(function() {
    $(".card-title").dotdotdot();
    $("label.place").dotdotdot();
  });

  $('#details-modal').on('show.bs.modal', function(event) {
    var button = $(event.relatedTarget); // Button that triggered the modal
    var event = button.data('event');
    var route = button.data('route');

    // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
    // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
    modal = $(this)

    modal.find('.modal-header').css('background', 'url(' + route + '/events/' + event.image + ')');

    modal.find('#titleModal').text(event.title);

    if (event.cost) {
      modal.find('#cost').css('display', 'block');
    } else {
      modal.find('#cost').css('display', 'none');
    }

    if (event.description != "") {
      modal.find('#description').css('display', 'block');
      modal.find('#descriptionModal').text(event.description);
    } else {
      modal.find('#description').css('display', 'none');
    }

    if (event.startDate == event.endDate) {
      modal.find('#dateModal').text(moment(event.startDate).format('dddd D [de] MMMM'));
    } else {
      modal.find('#dateModal').text('Del ' + moment(event.startDate).format('dddd D [de] MMMM') + ' al ' + moment(event.endDate).format('dddd D [de] MMMM'));
    }

    if (event.schedule != "00:00") {
      modal.find('#schedule').css('display', 'block');
      modal.find('#scheduleModal').text(event.schedule);
    } else {
      modal.find('#schedule').css('display', 'none');
    }

    $("#places > div").remove(); //Remove all previous places to add new ones

    var modalPlaces = modal.find('#places'); //Find parent places div

    $.each(event.places, function(index, value) {
      var place = "";
      if (value.area != "") {
        place += value.area + ", ";
      }
      place += value.name;

      modalPlaces.append("<div class='col-xs-9 col-md-9'><label>" + place + "</label></div>");
      if (value.logo != "") {
        modalPlaces.append("<div class='col-xs-3 col-md-3'><img src='" + route + '/logos/' + value.logo + "' class='logo-modal'></div>");
      } else {
        modalPlaces.append("<div class='col-xs-3 col-md-3'></div>");
      }
    });

  //modal.find('.modal-body input').val(recipient)
  });

  $('#details-modal').on('shown.bs.modal', function(event) {
    var button = $(event.relatedTarget); // Button that triggered the modal
    var event = button.data('event');
    var route = button.data('route');

    google.maps.event.trigger(map, 'resize');

    //Remove all the markers on map
    for (i = 0; i < gmarkers.length; i++) {
      gmarkers[i].setMap(null);
    }

    $.each(event.places, function(index, value) {
      var myLatlng = new google.maps.LatLng(value.lat, value.lng);
      map.setCenter(myLatlng);

      var marker = new google.maps.Marker({
        position: myLatlng,
        map: map
      });

      // Push your newly created marker into the array:
      gmarkers.push(marker);
    });
  });

  //document.getElementById('player').play();
  // invoke the carousel
  $('#main-carousel').carousel({
    interval: 6000
  }).on('slid.bs.carousel', function() {
    // This variable contains all kinds of data and methods related to the carousel
    var carouselData = $(this).data('bs.carousel');
    var currentIndex = carouselData.getItemIndex(carouselData.$element.find('.item.active'));
    //console.log(currentIndex);
    if (currentIndex == 0) {
      //document.getElementById('player').play();
    }
  });

  /*$("#player").css({
    'height': $('.carousel-inner img').height(),
    'width': $(window).width()
  });*/

  $('#main-carousel').on('slide.bs.carousel', function() {
    // This variable contains all kinds of data and methods related to the carousel
    var carouselData = $(this).data('bs.carousel');
    var currentIndex = carouselData.getItemIndex(carouselData.$element.find('.item.active'));
    //console.log(currentIndex);
    if (currentIndex == 0) {
      //document.getElementById('player').pause();
      //$('.item.active').find('iframe').contents().find('body').find('video')[0].play();
    }
  });
});

function initMap() {
  var myLatlng = new google.maps.LatLng(18.8943823, -96.935382);

  var myOptions = {
    zoom: 14,
    center: myLatlng,
    fullscreenControl: true
  };

  map = new google.maps.Map($('#map')[0], myOptions);
}